module.exports = __webpack_public_path__ + "officialStatic/img/news-title1.8382bab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news-title1.png
// module id = Ddg/
// module chunks = 0